import Repeater from './Repeater';

document.addEventListener('DOMContentLoaded', () => {
  const repeaterContainers = document.querySelectorAll('.js-repeater-add');
  const instances = [];

  repeaterContainers.forEach(button => {
    try {
      const instance = new Repeater(button);
      instances.push(instance);
    } catch (error) {
      console.error('Erreur lors de l\'initialisation du répéteur :', error);
    }
  });

  // Specific participants

  const participantsContainer = document.querySelector('.js-participants');

  if (participantsContainer) {
    const firstLabel = participantsContainer.querySelector('label');
    firstLabel.className = 'u-h3 u-color-foreground';
  }
});
